import React, { useEffect } from "react";
import { X } from "lucide-react";
import { userInitials } from "../userFloorHelpers";

export default function UserOpsModalShell({
  open,
  onClose,
  title,
  eyebrow = "Account ops",
  tone = "default",
  user,
  ariaLabel,
  children,
  footer,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="au-modal-backdrop"
      onClick={onClose}
      role="presentation"
    >
      <div
        className={`au-modal au-modal-${tone}`}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel || title}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="au-modal-head">
          <div className="au-modal-head-copy">
            <p className="au-modal-eyebrow">{eyebrow}</p>
            <h3>{title}</h3>
          </div>
          <button
            type="button"
            className="au-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={14} aria-hidden />
          </button>
        </header>

        {user ? (
          <div className="au-modal-subject">
            <span className="au-modal-subject-avatar">{userInitials(user.name, user.email)}</span>
            <span className="au-modal-subject-copy">
              <strong>{user.name || "Unknown"}</strong>
              <em>{user.email || "No email"}</em>
            </span>
            {user.inviteCode ? (
              <span className="au-modal-subject-code">#{user.inviteCode}</span>
            ) : null}
          </div>
        ) : null}

        <div className="au-modal-body">{children}</div>

        {footer ? <footer className="au-modal-foot">{footer}</footer> : null}
      </div>
    </div>
  );
}
